import { Box, Divider, MenuItem, Select, Typography } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import React, { useState } from 'react';
import userStyles from '../../app/user-management/UserStyle';
import { RoleLocationList, Status, UserRole } from '../../types';
import { RoleLocation } from '../RoleLocation/RoleLocation';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { StatusTag } from '../StatusTag/StatusTag';
type Props = {
    roleData: Array<{
        roleId: string;
        roleName: string;
    }>;
    userRoleId: string;
    roleChange: Function;
    selectedLocation: Function;
    addRow: Function;
};
export const DemoteOrgAdmin: React.FC<Props> = (props) => {
    const classes = userStyles();
    const { t } = useLanguageLocale();
    const [demoteOrgAdmin, setDemoteOrgAdmin] = useState(false);

    const onRoleChange = (event: string): void => {
        const selectedRole = props.roleData.find((role) => role.roleId === event);
        if (selectedRole && selectedRole.roleName !== UserRole.OrgAdmin) setDemoteOrgAdmin(true);
    };
    const addRoleChange = (data: RoleLocationList): void => {
        props.roleChange(data);
    };
    const removeAdditionalRow = (data: RoleLocationList): void => {
        props.selectedLocation(data);
    };
    const onSelectedLocation = (data: RoleLocationList): void => {
        props.selectedLocation(data);
    };
    const onAddRow = (data: RoleLocationList): void => {
        props.addRow(data);
    };
    return (
        <>
            {!demoteOrgAdmin && (
                <Box
                    width="100%"
                    flexDirection="row"
                    alignItems="center"
                    data-testid="orgadmin-selected"
                    display="flex"
                    style={{ padding: 24 }}
                >
                    <PersonIcon className={classes.IconStyle} data-testid="person-icon"></PersonIcon>

                    <Select
                        label="Role"
                        value={props.userRoleId}
                        inputProps={{
                            'data-testid': 'org-role',
                        }}
                        style={{ width: '40%' }}
                        className={classes.addUserformControl}
                        onChange={(e): void => {
                            onRoleChange(e.target.value);
                        }}
                    >
                        {props.roleData.map((roleInfo) => (
                            <MenuItem key={roleInfo.roleId} value={roleInfo.roleId}>
                                {roleInfo.roleName}
                            </MenuItem>
                        ))}
                    </Select>
                    <Box
                        width="100%"
                        display="flex"
                        flexDirection="row"
                        alignItems="center"
                        style={{ paddingLeft: 48 }}
                        data-testid="user-status"
                    >
                        <StatusTag status={Status.Active} style={{ float: 'left' }}/>
                    </Box>
                </Box>
            )}

            {demoteOrgAdmin && (
                <Box>
                    <Typography variant="body1" color="error" style={{ margin: 20 }} data-testid="demote-message1">
                        {t('EDITUSER.DEMOTE')}
                    </Typography>
                    <Typography data-testid="demote-message2" variant="body1" color="error" style={{ margin: 20 }}>
                        {t('EDITUSER.DEMOTE_CONFIRMATION')}
                    </Typography>
                    <Divider />
                    <Box style={{ margin: 20 }} data-testid="role-location-section">
                        <RoleLocation
                            roleData={props.roleData}
                            onRoleChange={addRoleChange}
                            removeAddRow={removeAdditionalRow}
                            onSelectLocation={onSelectedLocation}
                            AddRow={onAddRow}
                            existingLocation={[]}
                            isEdit={true}
                        ></RoleLocation>
                    </Box>
                </Box>
            )}
        </>
    );
};
